import React, { useState } from 'react';
import Ledger, {LedgerColumn} from 'src/components/Ledger';
import EmptyState from 'src/components/EmptyState';
import { FIELD_DETAILS_BY_FIELD_TYPE } from 'src/views/constants/fieldConstants';
import {Column, FieldType, Widget} from "src/types";

interface Props {
    widget: Widget,
    columns: Column[],
    ledgerColumns: LedgerColumn[],
    actions: React.ReactNode,
}

const FakeLedgerRenderer = ({ widget, columns, ledgerColumns, actions }: Props) => {
    const { isPaginated, isSearchable, isSortable } = widget.data;
    const [queryParams, setQueryParams] = useState({
        page_size: 10,
        page: 1,
        ordering: null,
        filters: null,
        search: null,
    });
    const updateQueryParams = (update: any) => {
        const newQueryParams = {
            ...queryParams,
            ...update,
        };
        setQueryParams(newQueryParams);
    };
    const setPage = (page: any) => updateQueryParams({ page });
    const setLimit = (page_size: any) => updateQueryParams({ page_size });
    const setFilters = (filters: any) => updateQueryParams({ filters });
    const setSort = (ordering: any) => updateQueryParams({ ordering });
    const setQuery = (search: any) => updateQueryParams({ search, page: 1 });
    const generateFakeResults = () => {
        const _fakeResults: Array<any> = [];
        // @ts-ignore
        [...Array(queryParams.page_size).keys()].forEach(() => {
            const fakeRow: Record<string, any> = {};
            columns.forEach(({ type, attribute }: { type: FieldType, attribute: string }) => {
                fakeRow[attribute] = FIELD_DETAILS_BY_FIELD_TYPE[type].generateFakeData();
            });
            _fakeResults.push(fakeRow);
        });
        return _fakeResults;
    };
    const fakeResults = generateFakeResults();
    return (
        <Ledger
            results={fakeResults}
            rawResults={{
                results: fakeResults,
                count: 999,
            }}
            columns={ledgerColumns}
            emptyState={<EmptyState />}
            isPaginated={isPaginated}
            isSearchable={isSearchable}
            isSortable={isSortable}
            setPage={setPage}
            setLimit={setLimit}
            setQuery={setQuery}
            setSort={setSort}
            setFilters={setFilters}
            query={(queryParams as any).query}
            limit={queryParams.page_size}
            page={queryParams.page}
            actions={actions}
        />
        );
};

export default FakeLedgerRenderer;
